import Swal from "sweetalert2";
import React from "react";
import { connect } from "react-redux";
import PageHeader from "../../components/PageHeader";
import { Avatar, Button, Card, Space, Tag } from "antd";
import { CopyTextToClipboard } from "../../helpers/copy";
import { t } from "i18next";
import { removeSlashesFromPath } from "../../helpers/location/removeSlashesFromPath";
import { EyeOutlined } from "@ant-design/icons";
import { Table, Input } from "antd";
import Apisetting from "../../api/Apisetting";
import AppContext from "../../components/AppContext";
import { formatPromptPayNumber, showToast } from "../../utils";
import {
  tagsBageStatus,
  tagsColorBalance,
  tagsColorLimitLeft,
  tagsTypeBage,
} from "../../helpers/tagsBage";
import { DrawerStatement } from "../../components/Drawer";
import { withTranslation } from "react-i18next";
import { BankData } from "../../Data/BankData";

const { Search } = Input;

class Index extends React.Component {
  static contextType = AppContext;

  constructor(props) {
    super(props);
    this.state = {
      activeTabKey1: "tab1",
      show: false,
      showModelAdd: false,
      showModelEdit: false,
      isData: null,
      isLoad: false,
      formData: {
        username: "",
        password: "",
      },
      dataTable: [],
      tableParams: {
        pagination: {
          current: 1,
          pageSize: 10,
          total: 0,
        },
        filters: {},
        sortField: null,
        sortOrder: null,
      },
    };
  }

  componentDidMount() {
    this.fetchData();
    this.context.getDataBankGropu();
    this.context.getAllDataMerchang();
  }

  componentDidUpdate(prevProps, prevState) {
    const { tableParams } = this.state;
    const { tableParams: prevTableParams } = prevState;

    const paginationChanged =
      tableParams.pagination?.current !== prevTableParams.pagination?.current ||
      tableParams.pagination?.pageSize !== prevTableParams.pagination?.pageSize;

    const sortChanged =
      tableParams.sortOrder !== prevTableParams.sortOrder ||
      tableParams.sortField !== prevTableParams.sortField;

    const filtersChanged =
      JSON.stringify(tableParams.filters) !==
      JSON.stringify(prevTableParams.filters);

    if (paginationChanged || sortChanged || filtersChanged) {
      this.fetchData();
    }
  }

  setLoading = (_loading) => {
    this.setState({ isLoad: _loading });
  };

  showToast = (icon, title) => {
    const Toast = Swal.mixin({
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 3500,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.onmouseenter = Swal.stopTimer;
        toast.onmouseleave = Swal.resumeTimer;
      },
    });
    Toast.fire({
      icon: icon,
      title: title,
    });
  };

  fetchData = async () => {
    this.setLoading(true);
    const { tableParams } = this.state;
    try {
      const res = await Apisetting.getAllBankAccount();
      if (res.data.success) {
        const isDataBank = res.data.data[0]?.bankAccounts;
        const fetchedData = Array.isArray(isDataBank) ? isDataBank : [];

        const filteredData = tableParams.filters.accountNumber
          ? fetchedData.filter((item) =>
              item.accountNumber
                .toLowerCase()
                .includes(tableParams.filters.accountNumber.toLowerCase())
            )
          : fetchedData;

        this.setState((prevState) => ({
          dataTable: filteredData,
          tableParams: {
            ...prevState.tableParams,
            pagination: {
              ...prevState.tableParams.pagination,
              total:
                filteredData.length < 10
                  ? filteredData.length
                  : res.data.data.count || filteredData.length, // Ensure total is correct, use filteredData.length if count is not available
              current: tableParams.pagination.current,
              pageSize: tableParams.pagination.pageSize,
            },
          },
        }));
      } else {
        showToast("error", res.message || "Failed to fetch data.");
      }
    } catch (error) {
      showToast("error", error.message || "Failed to fetch data.");
      console.error("Error fetching data:", error);
      this.setState({ dataTable: [] });
    } finally {
      this.setLoading(false);
    }
  };

  render() {
    const { isInbox } = this.props;
    const { resBankGroupData, resAllDataMerchang } = this.context;
    const { activeTabKey1, show, isData, isLoad, tableParams, dataTable } =
      this.state;

    const setActiveTabKey1 = (key) => {
      this.setState({ activeTabKey1: key });
    };

    const handleShow = (key) => {
      this.setState({ show: true, isData: key });
    };

    const handleClose = () => {
      this.setState({
        show: false,
        isData: null,
      });
    };

    const onTab1Change = (key) => {
      setActiveTabKey1(key);
    };

    const onSearch = (value) => {
      this.setState(
        (prevState) => ({
          tableParams: {
            ...prevState.tableParams,
            pagination: {
              ...prevState.tableParams.pagination,
              current: 1, // Reset to first page on search
            },
            filters: {
              ...prevState.tableParams.filters,
              accountNumber: value,
            },
          },
        }),
        () => this.fetchData() // Fetch data after state update
      );
    };

    const tabList = [
      {
        key: "tab1",
        tab: t("bank_list"),
      },
    ];

    const columns = [
      {
        title: t("#"),
        // dataIndex: "id", // ไม่จำเป็นต้องใช้ dataIndex ถ้าต้องการ ID ที่คำนวณใหม่
        key: "computed-id", // กำหนด key ที่ไม่ซ้ำกัน
        render: (text, record, index) => <>{index + 1}</>, // แสดง ID เรียงจาก 1, 2, 3...
        width: 70, // กำหนดความกว้างของคอลัมน์ (ตามความเหมาะสม)
      },
      {
        title: t("Account Name"),
        filterSearch: true,
        dataIndex: "accountName",
        key: "accountName",
        render: (accountName) => (
           
          <span style={{cursor:"copy"}} onClick={() => CopyTextToClipboard(accountName)}>
            {!accountName ? (
              <em style={{ color: "#888" }}>
                <small>{t("No data")}</small>
              </em>
            ) : (
              accountName
            )}
          </span>
        ),
      },
      {
        title: t("Bank"),
        filterSearch: true,
        dataIndex: "bank", // เพิ่ม dataIndex สำหรับ 'bank' เพื่อให้ sorter/filter ทำงานได้
        key: "bank",
        render: (bank) => (
          <span
            className="text-truncate"
            style={{
              maxWidth: "60px",
              textTransform: "capitalize",
            }}
          >
            <span style={{ textTransform: "uppercase" }}>
              <Avatar
                size={24}
                src={
                  BankData?.find((o) => o?.bank_id === bank?.bank_id)?.bankLogo
                }
              />{" "}
              - <b>{t(bank.bank_id)}</b>
            </span>
            
          </span>
        ),
      },
      {
        title: t("Account Number"),
        filterSearch: true,
        dataIndex: "accountNumber",
        key: "accountNumber",
        render: (accountNumber) => (
          <span
            onClick={() => CopyTextToClipboard(accountNumber)}
            style={{ cursor: "copy", maxWidth: "60px",  }}
            className="text-truncate"
          >
            {accountNumber ? (
              <>
                {" "}
                {formatPromptPayNumber(accountNumber)}{" "}
              </>
            ) : (
              <em style={{ color: "#888" }}>{t("No data")}</em>
            )}
          </span>
        ),
      },
      {
        title: <>{t("telephone number")}  /<br/> {t("Prompt Pay")}</>,
        dataIndex: "telephoneNumber",
        key: "telephoneNumber",
        render: (telephoneNumber) => ( 
          <span
            style={{ maxWidth: "150px", display: "inline-block", cursor:"copy" }}
            onClick={() => CopyTextToClipboard(telephoneNumber)}
            className="text-truncate"
          >
            {telephoneNumber === null ||
            telephoneNumber === undefined ||
            telephoneNumber === "" ? (
              <em style={{ color: "#888" }}>
                <small>{t("No data")}</small>
              </em>
            ) : (
              <>
                {formatPromptPayNumber(telephoneNumber)}{" "}
              </>
            )}
          </span>
        ),
        // sorter: (a, b) => a.accountNumber - b.accountNumber,
        sorter: false,
      },
      {
        title: t("Type"),
        filterSearch: true,
        dataIndex: "accountType",
        key: "accountType",
        render: (accountType) => (
          <span
            style={{ cursor: "copy", maxWidth: "60px" }}
          >
            {accountType ? (
              <Tag
                color={tagsTypeBage(accountType)}
                children={<strong>{accountType}</strong>}
              />
            ) : (
              <em style={{ color: "#888" }}>{t("No data")}</em>
            )}
          </span>
        ),
      },
      {
        title: t("Balance"),
        dataIndex: "balance",
        filterSearch: true,
        key: "balance",
        render: (balance) => (
          <span style={{ color: tagsColorBalance(balance) }}>
            {balance !== undefined && balance !== null ? ( // ตรวจสอบ balance ให้ดีขึ้น
              Intl.NumberFormat().format(balance)
            ) : (
              <em style={{ color: "#888" }}>{t("No data")}</em>
            )}
          </span>
        ),
      },
      {
        title: t("limit left"),
        dataIndex: "limit_Left",
        filterSearch: true,
        key: "limit_Left",
        render: (limit_Left) => (
          <span style={{ color: tagsColorLimitLeft(limit_Left) }}>
            {limit_Left !== undefined && limit_Left !== null ? ( // ตรวจสอบ limit_Left ให้ดีขึ้น
              Intl.NumberFormat().format(limit_Left)
            ) : (
              <em style={{ color: "#888" }}>{t("No data")}</em>
            )}
          </span>
        ),
      },
      {
        title: t("Status"),
        filterSearch: true,
        dataIndex: "status_bank",
        key: "status_bank",
        render: (status_bank) => (
          <span>
            {status_bank ? (
              <Tag color={tagsBageStatus(status_bank)} children={status_bank} />
            ) : (
              <em style={{ color: "#888" }}>{t("No data")}</em>
            )}
          </span>
        ),
      },
      {
        title: <span className="text-truncate">{t("action")}</span>,
        key: "action", // กำหนด key สำหรับคอลัมน์ action
        // fixed: "right", // สามารถเปิดใช้งานได้หากต้องการให้คอลัมน์ action อยู่ทางขวาเสมอ
        // width: 100,
        render: (_, record) => {
          return (
            <>
              <Space size="middle">
                <div title={t("Details")}>
                  <Button
                    icon={<EyeOutlined />}
                    onClick={() => handleShow(record)}
                    shape="circle"
                  />
                </div>
              </Space>
            </>
          );
        },
      },
    ];

    const handleTableChange = (pagination, filters, sorter) => {
      this.setState(
        (prevState) => ({
          tableParams: {
            ...prevState.tableParams,
            pagination,
            // filters, // ไม่ต้องใส่ filters ตรงนี้ถ้าใช้ onSearch จัดการแล้ว
            sortField: sorter.field,
            sortOrder: sorter.order,
          },
        }),
        this.fetchData
      );
    };

    const contentList = {
      tab1: (
        <>
          <div className="body table-responsive">
            <Table
              className="col-lg-12"
              columns={columns}
              rowKey={(record) => record.id} // ใช้ record.id เป็น key สำหรับแต่ละแถว
              onChange={handleTableChange}
              dataSource={dataTable}
              loading={isLoad}
              pagination={{
                ...tableParams.pagination,
                showSizeChanger: true,
                locale: {
                  items_per_page: `/ ${t("paged")}`, 
                },
                showTotal: (total, range) => {
                  // คำนวณหน้าปัจจุบัน
                  const currentPage = tableParams.pagination.current;
                  // คำนวณจำนวนหน้าทั้งหมด
                  const totalPages = Math.ceil(total / tableParams.pagination.pageSize);

                  return (
                    <span>
                      {/* แสดง: หน้า 1 จาก 10 | แสดง 1-10 จาก 100 รายการ */}
                      <strong>{t("Page", { page: Intl.NumberFormat().format(currentPage), totalPages: Intl.NumberFormat().format(totalPages) })}</strong>
                      <span style={{ marginLeft: 10 }}>
                        {t("Showing", { from: Intl.NumberFormat().format(range[0]), total: Intl.NumberFormat().format(total), of: Intl.NumberFormat().format(range[1]) })}
                      </span>
                    </span>
                  );
                },
              }}
              scroll={{ x: "max-content" }}
            />
          </div>
        </>
      ),
    };

    return (
      <>
        <DrawerStatement
          open={show}
          onClose={handleClose}
          isData={isData}
          resAllDataMerchang={resAllDataMerchang}
          resBankGroupData={resBankGroupData}
          t={t}
        />
        <div style={{ flex: 1 }}>
          <div>
            <div className="container-fluid">
              <PageHeader
                HeaderText={t("statements")}
                Breadcrumb={
                  isInbox
                    ? [
                        {
                          name: removeSlashesFromPath(window.location.pathname),
                          navigate: window.location.pathname,
                        },
                      ]
                    : null
                }
              />
            <br className="sm-hiden" />
            {isInbox ? (
                <>
                  <Card
                    title={<>{/* Removed Add Button for brevity */}</>}
                    extra={
                      <Search
                        placeholder={t("Search...")}
                        className=""
                        onSearch={onSearch}
                        enterButton
                      />
                    }
                    tabList={tabList}
                    activeTabKey={activeTabKey1}
                    onTabChange={onTab1Change}
                  >
                    {contentList[activeTabKey1]}
                  </Card>
                </>
              ) : null}
            </div>
          </div>
        </div>
      </>
    );
  }
}

const mapStateToProps = ({ mailInboxReducer }) => ({
  isInbox: mailInboxReducer.isInbox,
});

export default connect(mapStateToProps, {})(withTranslation()(Index));
